// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"640":"24268e8a","787":"2d04c633"}[chunkId] + ".chunk.js";
};